import { useContext, useEffect, useState } from "react";

import "../../styles/auth.css";
import "../../styles/index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import { AuthenticationContext } from "../../services/authentication/authentication.context";
import { Loader } from "../../components/utilities/loader";
import { AppAlert } from "../../components/utilities/alert";

export const ResetPassword = () => {

    const { isLoading, recoverPassword } = useContext(AuthenticationContext);

    const token = new URLSearchParams(window.location.search).get("resetToken");

    const [credentials, setCredentials] = useState({
        password: '',
        repeatPassword: '',
    });

    const [toggleShow, setToggleShow] = useState(false);
    const [toggleShow1, setToggleShow1] = useState(false);
    const [onAlert, setOnAlert] = useState();
    const [isWeak, setIsWeak] = useState();



    const { password, repeatPassword } = credentials;

    const isNull = (v) => v === '' || v === null || v === undefined;

    const handleValidate = (value) => {
        if (value.length < 8) {
            setIsWeak(true);
        } else {
            setIsWeak(false);
        }
    }

    const handleSubmit = async () => {
        if (isNull(password) || isNull(repeatPassword)) {
            setOnAlert({
                caption: "Error!",
                message: "Provide data for passwords!",
                accept: "OK",
                acceptAction: () => setOnAlert(),
            })

            return;
        }

        if (password !== repeatPassword) {
            setOnAlert({
                caption: "Error!",
                message: "Passwords do not match!",
                accept: "OK",
                acceptAction: () => setOnAlert(),
            })

            return;
        }
        try {
            const res = await recoverPassword(password, repeatPassword, token);
            console.log(res);
            if (res?.error) {
                setOnAlert({
                    caption: "Error!",
                    message: res?.error,
                    accept: "OK",
                    acceptAction: () => setOnAlert(),
                })

                return;
            }
            setOnAlert({
                caption: "Success!",
                message: res?.message,
                accept: "OK",
                acceptAction: () => {
                    setOnAlert();
                },
            })
        } catch (error) {
            console.log({ error })
        }
    }

    useEffect(() => {
        if (!token) {
            setOnAlert({
                caption: "Unauthorized!",
                message: "No reset token found!",
                accept: "OK",
                acceptAction: () => window.location.href = "/",
            })
        }
    }, [token])

    return (
        <div className={classNames("scroll-page")}>
            {isLoading && (<Loader />)}
            {onAlert &&
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    acceptAction={onAlert.acceptAction}
                    close={() => setOnAlert()}
                />
            }
            <div className="page-caption">
                <span className="wlc">Welcome back!</span>
                <span className="wlc-cap">Create a strong password</span>
                <span className="wlc">(at least 8 characters)</span>
            </div>
            <div className="form-container">

                <div className="input-container">
                    <span className="input-cap">Password</span>
                    <input
                        type={toggleShow ? "text" : "password"}
                        value={password}
                        className="input"
                        placeholder="type your password"
                        onChange={(e) => {
                            handleValidate(e.target.value);
                            setCredentials((creds) => (
                                { ...creds, password: e.target.value }
                            ));
                        }}
                    />
                    <button
                        className="eye-icon"
                        onClick={() => setToggleShow1((t) => !t)}
                    >
                        <FontAwesomeIcon
                            icon={toggleShow1 ? faEye : faEyeSlash}
                        />
                    </button>
                </div>
                <div className="input-container">
                    <span className="input-cap">Confirm password</span>
                    <input
                        type={toggleShow ? "text" : "password"}
                        value={repeatPassword}
                        className="input"
                        placeholder="type your password"
                        onChange={(e) => setCredentials((creds) => (
                            { ...creds, repeatPassword: e.target.value }
                        ))}
                    />
                    <button
                        className="eye-icon"
                        onClick={() => setToggleShow((t) => !t)}
                    >
                        <FontAwesomeIcon
                            icon={toggleShow ? faEye : faEyeSlash}
                        />
                    </button>
                </div>

                {isWeak !== undefined &&
                    <div className={classNames("pass-strength", { 'weak-pass': isWeak })}>
                        {isWeak === true ?
                            "Password is too weak (length less than 8 characters)" :
                            "Password is ok (length greater than 8 characters)"
                        }
                    </div>
                }

                <button
                    className={classNames("form-button",{'dis': isWeak})}
                    onClick={handleSubmit}
                    disabled={isWeak}
                >
                    Reset password
                </button>

            </div>
        </div>
    );
}
